import { render, staticRenderFns } from "./TraceabilityEdit.vue?vue&type=template&id=9505735c&lang=pug&"
import script from "./TraceabilityEdit.vue?vue&type=script&lang=ts&"
export * from "./TraceabilityEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports